import {createContext, useContext, useReducer} from 'react';
import {useUpdateEffect} from 'react-use';

const initialState = {elements: [], isSideBarVisible: true};

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_ELEMENTS_ACTION':
      return {...state, elements: action.payload};
    case 'SELECT_ELEMENT_ACTION':
      return state?.elementSelected?.url !== action?.payload?.url
        ? {...state, elementSelected: action.payload}
        : state;
    case 'TOGGLE_SIDEBAR_VISIBLE_ACTION':
      return {...state, isSideBarVisible: !state.isSideBarVisible};
    default:
      return state;
  }
}

const PdfViewerStateContext = createContext(initialState);
const PdfViewerDispatchContext = createContext(undefined);

export const PdfViewerProvider = props => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    elements: props?.elements || [],
    elementSelected: props?.elements?.[0]
  });

  useUpdateEffect(() => {
    dispatch({type: 'SET_ELEMENTS_ACTION', payload: props?.elements || []});
    dispatch({type: 'SELECT_ELEMENT_ACTION', payload: props?.elements?.[0]});
  }, [props?.elements]);

  return (
    <PdfViewerStateContext.Provider value={state}>
      <PdfViewerDispatchContext.Provider value={dispatch}>{props.children}</PdfViewerDispatchContext.Provider>
    </PdfViewerStateContext.Provider>
  );
};

export const PdfViewerConsumer = ({children}) => {
  return (
    <PdfViewerStateContext.Consumer>
      {value => children(value)}
    </PdfViewerStateContext.Consumer>
  );
};

export function usePdfViewerState() {
  const context = useContext(PdfViewerStateContext);
  const dispatch = usePdfViewerDispatch();

  if (context === undefined) {
    throw new Error(`usePdfViewerState must be used inside a PdfViewerProvider`);
  }

  return {...context, toggleShowSidebar: () => dispatch({type: 'TOGGLE_SIDEBAR_VISIBLE_ACTION'})};
}

export function usePdfViewerDispatch() {
  const context = useContext(PdfViewerDispatchContext);

  if (context === undefined) {
    throw new Error(`usePdfViewerDispatch must be used inside a PdfViewerProvider`);
  }

  return context;
}
